import { render, staticRenderFns } from "./InvoiceDetailsList.vue?vue&type=template&id=4a8f970a&scoped=true&"
import script from "./InvoiceDetailsList.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsList.vue?vue&type=style&index=0&id=4a8f970a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f970a",
  null
  
)

export default component.exports